const en = {
  meta: {
    title: "Jaime Gimillo | Computer Scientist and Mathematician",
  },
  header: {
    subtitle: "Computer Scientist and Mathematician",
    subtitleShort: "CS & Mathematician",
    language: "Language",
  },
  card: {
    greeting: "Hi, I'm Jaime.",
    greetingMobile: ["Hi,", "I'm Jaime."],
    intro:
      "Welcome to a small website that tells who I am, what I do and why. " +
      "You'll also find a few things I've written that, with any luck, might help you.",
    bye: "Cheers.",
  },
  projects: {
    title: "Featured projects",
    corec:
      "An open-source library for the implementation and evaluation of context-aware recommender systems.",
    smartAssure:
      "Developer for 9 months on an LLM-based tool for document classification and field extraction.",
    adAstra:
      "A small space exploration video game made with my university classmates.",
    chatBabel:
      "A chat application that lets users translate messages written in a language other than their own.",
  },
  contactAside: {
    title: "Contact",
    location: "Madrid, Spain",
  },
  aboutMe: {
    title: "About me",
    p1:
      "The happiest time of the week at school was Tuesday mornings. We had ICT class. " +
      "The worst, without a doubt, Tuesday afternoons.",
    p2:
      "I ended up studying a STEM degree, a double degree in Computer Science and Mathematics. " +
      "Possibly the worst, but above all the best, decision I've ever made in my life.",
    p3:
      "Here are my Bachelor's theses, in case you're curious to find out what cost me a few diopters:",
    tfgMath: "Mathematics Thesis",
    tfgInfo: "Computer Science Thesis",
    p4:
      "Now, I'm starting my professional career in the field of Artificial Intelligence. " +
      "That combination of probability and computation is what, to me, makes it so appealing. " +
      "I'm sure that in a few years, this technology will have already transformed the way we " +
      "understand knowledge and the reality around us.",
    p5:
      "If you're interested, below you can check out my full CV along with a few facts about my, for now, " +
      "brief career:",
    years: "Years",
    projects: "Projects",
  },
  contact: {
    title: "Let's talk",
    subtitle: "Have a project? Write to me.",
    name: "Name",
    email: "Email",
    message: "Message",
    send: "Send",
    orMail: "Or email me at",
    success: "Thanks for reaching out!",
    error: "Error sending: ",
  },
  blog: {
    title: "Personal blog",
    quote: "“When one teaches, two learn.”",
    comingSoon: "Coming soon",
    toc: "Contents",
    onlySpanish: "Only available in Spanish for now",
  },
  comments: {
    title: "Comments",
    name: "Name",
    namePlaceholder: "Your name",
    comment: "Comment",
    commentPlaceholder: "Write your comment...",
    success: "Comment sent successfully!",
    sending: "Sending...",
    submit: "Send comment",
    empty: "No comments yet. Be the first to comment!",
    errorEmpty: "Please fill in all the fields.",
    errorShort: "The comment is too short.",
    errorSend: "Error sending the comment. Please try again.",
    justNow: "Just now",
  },
};

export default en;
